import { render, staticRenderFns } from "./CreateRoomLimit.vue?vue&type=template&id=593d4b1c&scoped=true&"
import script from "./CreateRoomLimit.vue?vue&type=script&lang=js&"
export * from "./CreateRoomLimit.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoomLimit.vue?vue&type=style&index=0&id=593d4b1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d4b1c",
  null
  
)

export default component.exports